import api from '../api';

export const userAuditApi = api.injectEndpoints({
  endpoints: builder => ({
    fetchAllUserAuditDetails: builder.query({
      query: () => ({
        url: 'api/user/activity/records',
        method: 'GET'
      })
    })
  })
});

export const {
  useFetchAllUserAuditDetailsQuery,
  useLazyFetchAllUserAuditDetailsQuery
} = userAuditApi;
